import React from "react";
import AccessDenied from "./AccessDenied";

export default function UnAuthorized() {
  return <AccessDenied />;
}
